import { DomainLayout } from "@/components/layouts/DomainLayout";
import { ProfileView } from "../views/ProfileView";

export const ProfilePage = () => {
  return (
    <DomainLayout>
      <ProfileView />
    </DomainLayout>
  );
};
